export class MDFreedomFighterBodyModel {
    constructor(
        public nameAsOnCertificate: string,
        public isStampReadable: string,
        public isStampFromDistrictCollectorOfficer: string,
        public isSignaturePresent: string,
        public isDateOfIssuePresent: string,
        // public isQRCodePresent: string,
    ) { }
}